import Popup from "components/Popup";
import ProjectRoles from "components/Project/ProjectRoles";
import ProjectInfo from "components/ProjectInfo";
import { deleteRequest } from "core/Api";
import routes from "core/Routes";
import MainLayout from "layouts/MainLayout";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { fetchProjectById } from "store/slices/exploreSlice";
import styled from "styled-components";
import themeProps from "theme/themes";
import { isMember, isOwner } from "utils/projectUtils";

const Wrapper = styled.div`
  position: relative;
`;

const Button = styled.button`
  color: ${(props: themeProps) => props.theme.button.warning};
  background-color: transparent;
  border: none;
  outline: none;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  margin-top: 50px;
`;

const Text = styled.p`
  margin-bottom: 70px;
  font-size: 1.2rem;
`;

const ProjectPreview = () => {
  const { t } = useTranslation("project");
  const history = useHistory();
  const params: any = useParams();
  const dispatch = useAppDispatch();
  const project = useAppSelector((state) => state.explore.selected);
  const userId = useAppSelector((state) => state.user.auth.userId);
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  useEffect(() => {
    dispatch(fetchProjectById(params.id));
  }, [dispatch, params.id]);

  const deleteProject = async () => {
    try {
      const data = await deleteRequest(`/projects/${project?._id}`);
      if (data._id) {
        history.push(routes.explore.root);
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  return (
    <MainLayout>
      <Wrapper>
        {project && <ProjectInfo project={project} />}
        {project?.roles &&
          (project.roles.filter((role) => !role.userId).length > 0 ? (
            <ProjectRoles project={project} />
          ) : null)}
        {isMember(project, userId) && !isOwner(project, userId) && (
          <Button onClick={() => console.log("LEAVE PROJECT")}>
            {t("exitProject")}
          </Button>
        )}
        {isOwner(project, userId) && (
          <Button onClick={() => setShowDeletePopup(true)}>
            {t("deleteProject")}
          </Button>
        )}
        {showDeletePopup && (
          <Popup
            heading={t("deleteProject")}
            handleClose={() => setShowDeletePopup(false)}
            cancelLabel={t("common:cancel")}
            warningLabel={t("deleteProject")}
            handleWarning={deleteProject}
            styles={{ top: "50%" }}
          >
            <Text>{t("deleteProjectWarning")}</Text>
          </Popup>
        )}
      </Wrapper>
    </MainLayout>
  );
};

export default ProjectPreview;
